export const CONTENT_SORT_ORDER = {
	"Pre-Game Activity": 1,
	"Game Rules": 2,
	"Game Play": 2,
	Assessment: 3,
};

export function getContentDisplayTitle(title) {
	if (!title) return title;
	if (title === "Game Rules") return "Game Play";
	return title;
}

export function sortContentsForUpload(contentsList) {
	return [...contentsList].sort((a, b) => {
		const orderA = CONTENT_SORT_ORDER[a.title] ?? 999;
		const orderB = CONTENT_SORT_ORDER[b.title] ?? 999;
		if (orderA !== orderB) return orderA - orderB;
		return String(a.title).localeCompare(String(b.title));
	});
}

export function isPreGameContentTitle(title) {
	return (title || "").toLowerCase().includes("pre-game");
}

export function isGamePlayContentTitle(title) {
	const normalized = (title || "").toLowerCase();
	if (isPreGameContentTitle(title)) return false;
	return (
		normalized.includes("game rule") ||
		normalized.includes("game play") ||
		normalized === "game rules"
	);
}
